import { ArrowRightIcon } from '@heroicons/react/outline'
import { ModalStore } from '../../state/ModalStore'
import HomepageBookCallLeadModal from '../Modals/HomepageBookCallLeadModal'

export const homepageButtonStyles = {
    primary:
        'inline-flex items-center justify-center gap-2 rounded-full bg-[linear-gradient(90deg,#ED5C2F_0%,#F28230_100%)] px-7 py-3.5 text-sm font-semibold text-white shadow-[0_4px_14px_-2px_rgba(237,92,47,0.35)] transition hover:-translate-y-0.5 hover:brightness-105',
    outline:
        'inline-flex items-center justify-center gap-2 rounded-full border border-[#ED5C2F] bg-white px-7 py-3.5 text-sm font-semibold text-[#ED5C2F] transition hover:-translate-y-0.5 hover:bg-[#FEF3EC]',
    light: 'inline-flex items-center justify-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-[#ED5C2F] transition hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(0,0,0,0.18)]',
}

function HomepageBookCallButton({
    children = 'Book a Call',
    variant = 'primary',
    className = '',
    showArrow = true,
    Modal = HomepageBookCallLeadModal,
    modalProps,
    onClick,
    ...props
}) {
    const addModal = ModalStore((state) => state.add)

    const handleClick = () => {
        addModal(<Modal {...modalProps} />)
    }

    return (
        <button
            type="button"
            onClick={onClick || handleClick}
            {...props}
            className={`${homepageButtonStyles[variant]} ${className}`.trim()}>
            <span>{children}</span>
            {showArrow && <ArrowRightIcon className="h-4 w-4" />}
        </button>
    )
}

export default HomepageBookCallButton
